module.exports = __webpack_public_path__ + "img/tag_fsbq.4550d7c7.png";